import type { ComponentProps } from 'react';

import { ROW, ROW_GO } from '@/components/layout';
import { cn } from '@/lib/utils';

export function GoRow({ children, className, ...rest }: ComponentProps<'button'>) {
  return (
    <button type="button" className={cn(ROW, className)} {...rest}>
      <span className="min-w-0">{children}</span>
      <span className={ROW_GO} aria-hidden>
        →
      </span>
    </button>
  );
}
